module.exports = __webpack_public_path__ + "static/media/credit_card.f1d22fa2.png";